import { createElement, forwardRef } from 'react'
import { mergeCss } from '../css/css.mjs';
import { splitProps } from '../helpers.mjs';
import { getListStyle } from '../patterns/list.mjs';
import { styled } from './factory.mjs';

export const List = /* @__PURE__ */ forwardRef(function List(props, ref) {
  const [patternProps, restProps] = splitProps(props, ["disablePadding"])

const styleProps = getListStyle(patternProps)
const cssProps = { css: mergeCss(styleProps, props.css) }
const mergedProps = { ref, ...restProps, ...cssProps }

return createElement(styled.ul, mergedProps)
  })